// @flow
import I18n from '../../../../lib/i18n';
import { extractRoamingZoneFromArrayElements } from '../../../../lib/RoamingZoneExtractor';
import { extractIddZoneFromArrayElements } from '../../../../lib/IddZoneExtractor';
import config from '../../../../config';

export const getTitleCore = (type: string, credits?: Array<Object>, parameters?: Object): string => {
  if (type === 'TOPUP_OK' && credits) {
    const iddZone = credits && extractIddZoneFromArrayElements(credits, 'type');
    if (iddZone) return I18n.t('Dashboard.Timeline.iddZone', { zone: iddZone });
    const roamingZone = extractRoamingZoneFromArrayElements(credits, 'type');
    if (roamingZone) {
      switch (roamingZone) {
        case 'ROAM_LIKE_HOME':
          return I18n.t('RoamingOffer.RoamLikeHome.offerName');
        case 'ROAM_LIKE_HOME2':
          return I18n.t('RoamingOffer.ExtendedRoamLikeHome.offerName');
        default:
          return I18n.t('RoamingOffer.RoamingPackage.offerName', { zone: roamingZone });
      }
    }
  }
  const isRLH = parameters && parameters.hasOwnProperty('RLH_AMOUNT');
  const isRLH2 = parameters && parameters.hasOwnProperty('RLH2_AMOUNT');
  if (isRLH) return I18n.t('timeline.DETAILS_RLH');
  if (isRLH2) return I18n.t('timeline.DETAILS_RLH2');
  return I18n.t(`timeline.DETAILS_${type}`);
};

export const getTitle = (type: string, credits?: Array<Object>, parameters?: Object): ?string => {
  if (type !== 'TOPUP_OK' || config.displayTopUpTimelineSubtitles) {
    return `**${I18n.t('purchased')}:** ` + getTitleCore(type, credits, parameters);
  }
  return null;
};
